/** Parse `s3://bucket/path/to/object` into bucket + key. */
export function parseS3FileUrl(fileURL) {
  if (typeof fileURL !== "string" || !fileURL.startsWith("s3://")) {
    return { bucket: "", key: fileURL || "" };
  }

  const parts = fileURL.replace("s3://", "").split("/");
  const bucket = parts.shift();
  const key = parts.join("/");
  return { bucket, key };
}

const DEFAULT_S3_REGION = "ap-south-1";

/**
 * Stable HTTPS URL for a CRM-uploaded object.
 * Prefer stripping query params from the presigned PUT URL; fall back to s3:// key.
 */
export function resolvePublicMediaUrl({ uploadURL, s3Key } = {}) {
  if (uploadURL) {
    try {
      const url = new URL(uploadURL);
      url.search = "";
      url.hash = "";
      return url.href;
    } catch {
      // fall through to s3 key
    }
  }

  if (typeof s3Key === "string" && s3Key.startsWith("s3://")) {
    const { bucket, key } = parseS3FileUrl(s3Key);
    if (bucket && key) {
      const encodedKey = key.split("/").map(encodeURIComponent).join("/");
      return `https://${bucket}.s3.${DEFAULT_S3_REGION}.amazonaws.com/${encodedKey}`;
    }
  }

  if (typeof s3Key === "string" && (s3Key.startsWith("http://") || s3Key.startsWith("https://"))) {
    return s3Key;
  }

  return "";
}
